import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const MemberSkeletonCard = () => {
  return (
    <div className="h-[111px] pl-4 pr-[26px] py-[15px] bg-white rounded-lg shadow flex justify-start mb-2">
      <div className="w-[10%]">
        <Skeleton circle height={40} width={40} />
      </div>
      <div className="w-full pl-2 mt-[-2px]">
        <Skeleton height={10} width={150} />
        <Skeleton height={8} width={100} />
        <Skeleton height={8} width={80} />
        <Skeleton height={8} width={120} />
      </div>
      <Skeleton height={10} width={60} />
    </div>
  );
};

export default MemberSkeletonCard;
